<template>
  <a-modal v-model="employeeVisible" title="选择员工" :width="600" :bodyStyle="{ padding: '0' }" centered
    wrapClassName="employeeModal" @cancel="employeeVisible = false;" :maskClosable="false">
    <div class="tree-wrapper">
      <div style="flex: 1;">
        <div class="header">
          <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
            全选
          </a-checkbox>
          <span class="statistics">{{ checkedKeys.length }}/{{ allEmployeeKeys.length }}</span>
        </div>
        <a-input-search style="padding: 6px;" :value="searchValue" placeholder="搜索" @change="onChange" />
        <a-tree v-model="checkedKeys" :expanded-keys="expandedKeys" :auto-expand-parent="autoExpandParent"
          :tree-data="treeDatas" :replaceFields="replaceFields" checkable @check="handleTreeCheck" @expand="onExpand">
          <template slot="name" slot-scope="{ name }">
            <span v-if="name.indexOf(searchValue) > -1">
              {{ name.substr(0, name.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ name.substr(name.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ name }}</span>
          </template>
        </a-tree>
      </div>
      <div style="flex: 1; border-left: 1px solid #DFE2E8;">
        <div class="header">已选择</div>
        <div v-for="(e, index) in selectedEmployees" class="employeeItem" :key="e.id">{{ e.name }}<a-icon
            class="li-close-icon" type="close-circle" @click="handleDelete(e, index)" /></div>
      </div>
    </div>
    <template slot="footer">
      <div></div>
      <div>
        <a-button @click="employeeVisible = false;">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="handleAddEmployee">
          确定
        </a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import SystemSetting from '@/api/systemSetting';
export default {
  props: {
    // 是否查询员工是否被分配授权到电子签
    electSignFlag: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      employeeVisible: false,
      disableList: [],
      excludeList: [],
      checkedKeys: [],
      allEmployeeKeys: [],
      indeterminate: false,
      checkAll: false,
      expandedKeys: [],
      autoExpandParent: true,
      treeDatas: [],
      replaceFields: {
        children: 'children',
        title: 'name',
        key: 'id',
      },
      searchValue: '',
      selectedEmployees: [],
      dataList: [],
      treeDataMap: {},
    };
  },
  watch: {
    employeeVisible (val) {
      if (!val) {
        this.checkedKeys = [];
        this.allEmployeeKeys = [];
        this.indeterminate = false;
        this.checkAll = false;
        this.expandedKeys = [];
        this.autoExpandParent = true;
        this.searchValue = '';
        this.selectedEmployees = [];
        this.dataList = [];
        this.treeDataMap = {};
      }
    },
  },
  // created () {
  //   this.getDepartmentsAndEmployees({});
  // },
  methods: {
    // 参数说明
    // selectedList: 已选择的员工列表
    // disableList: 禁用的员工列表
    // excludeList: 排除的员工列表
    async handleChooseEmployee (selectedList = [], disableList = [], excludeList = []) {
      this.checkedKeys = selectedList;
      this.disableList = disableList;
      this.excludeList = excludeList;
      await this.getDepartmentsAndEmployees({});
      this.autoExpandParent = true;
      this.searchValue = '';

      this.expandedKeys = [...this.allEmployeeKeys];

      this.employeeVisible = true;
    },
    handleTreeCheck (keys, e) {
      this.selectedEmployees = [];

      this.indeterminate = !!keys.length && keys.length < this.allEmployeeKeys.length;
      this.checkAll = keys.length === this.allEmployeeKeys.length;

      e.checkedNodes.forEach(node => {
        if (node.data.props.isEmployee) {
          this.selectedEmployees.push({
            id: node.data.props.id,
            name: node.data.props.name,
          });
        }
      });
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    handleDelete (v, idx) {
      let index = this.checkedKeys.findIndex(key => key === v.id);

      this.selectedEmployees.splice(idx, 1);

      if (index !== -1) {
        this.checkedKeys.splice(index, 1);
      }
    },
    onCheckAllChange (e) {
      this.indeterminate = false;
      this.checkAll = e.target.checked;

      this.checkedKeys = e.target.checked ? [...this.allEmployeeKeys] : [];

      // 禁用的员工不能选择
      this.checkedKeys = this.checkedKeys.filter(key => !this.disableList.includes(key));
      // 排除的员工不能选择
      this.checkedKeys = this.checkedKeys.filter(key => !this.excludeList.includes(key));

      this.selectedEmployees = [];

      if (e.target.checked) {
        const keys = Object.keys(this.treeDataMap);

        for (const k of keys) {
          // 禁用的员工不能选择
          if (this.disableList.includes(k)) {
            continue;
          }
          // 排除的员工不能选择
          if (this.excludeList.includes(k)) {
            continue;
          }
          this.selectedEmployees.push({
            id: k,
            name: this.treeDataMap[k],
          });
        }
      }
    },
    handleAddEmployee () {
      const selectedList = this.checkedKeys.map(k => {
        return {
          userId: k,
          userName: this.treeDataMap[k],
        };
      });
      this.$emit('chooseEmployee', selectedList);
      this.employeeVisible = false;
    },
    setRDepartmentsAndEmployeees (vals) {
      vals.forEach(v => {
        (v.employees || []).forEach(v => {
          v.isEmployee = true;

          if (!this.treeDataMap[v.id]) {
            this.treeDataMap[v.id] = v.name;
          }

          if (!this.allEmployeeKeys.includes(v.id)) {
            this.allEmployeeKeys.push(v.id);
          }

          v.scopedSlots = { title: 'name' };
        });

        (v.children || []).forEach(v => {
          v.checkable = false;

          v.scopedSlots = { title: 'name' };
        });

        v.children = [...(v.children || []), ...(v.employees || [])];

        if (v.children.length) {
          this.setRDepartmentsAndEmployeees(v.children);
        }
      });
    },
    getParentKey (key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.id === key)) {
            parentKey = node.id;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    onChange (e) {
      const value = e.target.value;

      const expandedKeys = this.dataList
        .map(item => {
          if (item.name.indexOf(value) > -1) {
            return this.getParentKey(item.id, this.treeDatas);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      this.searchValue = value;
      this.expandedKeys = expandedKeys;
    },
    generateList (data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        this.dataList.push({ id: node.id, name: node.name });
        if (node.children) {
          this.generateList(node.children);
        }
      }
    },
    // 递归禁用allocationToElectSignFlag:true的元素
    getElectSignFlag (arr) {
      arr.forEach(v => {
        if (v.children && v.employees?.length) {
          this.getElectSignFlag(v.employees);
        }
        if (v.allocationToElectSignFlag) {
          v.disableCheckbox = true;
          this.disableList.push(v.id);
        }
      });
    },
    // 递归禁用disableList中的元素
    getDisableList (arr) {
      arr.forEach(v => {
        if (v.children && v.employees?.length) {
          this.getDisableList(v.employees);
        }
        if (this.disableList.includes(v.id)) {
          v.disableCheckbox = true;
        }
      });
    },
    // 递归删除excludeList中的元素
    removeExcludeList (arr) {
      arr.forEach((v, index) => {
        if (v.children && v.employees?.length) {
          this.removeExcludeList(v.employees);
        }
        if (this.excludeList.includes(v.id)) {
          arr.splice(index, 1);
        }
      });
    },
    async getDepartmentsAndEmployees () {
      let { body } = await SystemSetting.getDepartmentLists({ findAllocationToElectSignFlag: this.electSignFlag });

      (body || []).forEach(v => {
        v.checkable = false;
        v.scopedSlots = { title: 'name' };
      });

      if (this.excludeList.length && body?.length) {
        this.removeExcludeList(body);
      }
      if (this.disableList.length && body?.length) {
        this.getDisableList(body);
      }
      if (this.electSignFlag) {
        this.getElectSignFlag(body);
      }

      this.setRDepartmentsAndEmployeees(body || []);

      this.treeDatas = body || [];

      this.generateList(this.treeDatas);
    },
  },
};
</script>
<style lang="scss" scoped>
.employeeModal {
  .tree-wrapper {
    display: flex;
    height: 60vh;
    overflow: auto;

    .header {
      position: relative;
      height: 40px;
      line-height: 40px;
      background: #F2F4F7;
      padding: 0 8px;
      border-bottom: 1px solid #DFE2E8;

      .statistics {
        position: absolute;
        right: 10px;
      }
    }

    .employeeItem {
      position: relative;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      padding: 0 9px;

      .li-close-icon {
        position: absolute;
        right: 9px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>
